import api from './api';

const listPills = query => api.get('/api/pills/', { params: query });

export default {
  listPills,
};
